import { UNITS } from "~/constants/unit";
import { getUserPreference } from "~/storages/preference";
import { UserPreferenceMeasurements } from "~/types/preference";

export const isImperial = () => {
  return getUserPreference() === UserPreferenceMeasurements.Imperial;
};

export const getUnit = (unitName?: string) => {
  if (!unitName) {
    return "";
  }
  if (
    unitName.toLowerCase() === UNITS.MILLIMETER ||
    unitName.toLowerCase() === UNITS.INCH
  ) {
    return isImperial() ? UNITS.INCH : UNITS.MILLIMETER;
  }

  if (unitName.toLowerCase() === UNITS.CELSIUS.toLocaleLowerCase()) {
    return isImperial() ? UNITS.FAHRENHEIT : UNITS.CELSIUS;
  }

  return unitName;
};

export const convertFahrenheitToUserPreference = (value: number) => {
  // Celsius to Celsius or fahrenheit based on user Preference.
  return isImperial() ? value : ((value - 32) * 5) / 9;
};

export const convertInchToUserPreference = (value: number) => {
  // inches to mm or mm based on user Preference.
  return isImperial() ? value : value * 25.4;
};

export const convertInchToUserPreferenceToFixed = (
  value: number,
  fixed: number = 0,
) => {
  return convertInchToUserPreference(value).toFixed(fixed);
};
